import { render, staticRenderFns } from "./dashboardNavdrawer.vue?vue&type=template&id=dc10c40c&scoped=true"
import script from "./dashboardNavdrawer.vue?vue&type=script&lang=js"
export * from "./dashboardNavdrawer.vue?vue&type=script&lang=js"
import style0 from "./dashboardNavdrawer.vue?vue&type=style&index=0&id=dc10c40c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc10c40c",
  null
  
)

export default component.exports